<mat-slide-toggle
  [disabled]="disabled"
  (input)="onInput($event)"
  color="primary"
  [matTooltip]="tooltip"
  [checked]="checked"
>
{{text}}
</mat-slide-toggle>
